import React, { useState } from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import SubmenuPacks from '../submenu/SubmenuPacks'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import { useParams } from 'react-router-dom'
import BoxOneOptions from './options/BoxOneOptions'
import BoxOneList from './BoxOneList'
import BoxOneOptionsHeader from './options/BoxOneOptionsHeader'

const BoxOne = () => {

    const { packId, boxId } = useParams()

  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuPacks />
		</MyBlock>
        <MyBlockHeader
            header={'Товари в коробці'}
            isBack={true}
            options={
                <BoxOneOptionsHeader
					boxId={boxId}
                />
            }
        />
        <MyBlock>
            <BoxOneOptions 
                boxId={boxId}
            />
        </MyBlock>
		<MyBlock>
        	<BoxOneList 
				boxId={boxId}
			/>
		</MyBlock>
    </LayoutMain>
  )
}

export default BoxOne